import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment';
import {makeStyles, Paper, Typography } from '@material-ui/core';



const useStyles = makeStyles((theme) => ({   
   Wrapper: {
        width: "100px",
        marginRight: "20px",
        backgroundColor: "red",
        height:"100px",
        overflow: "none"
   },
   Link: {
    width: "20px",
    textDecoration: "none",
    color: "black",
    padding: "5px",
    fontWeight: "bold",
    textAlign: "center",
    margin: "0 auto"
   },
   Typog: {
       fontWeight: "bold",
       fontSize: "15px",
       '&:hover': {
        color: "white",
     },
   },
   Paper: {
       backgroundColor: "#C8C8C8",
   }
}));




export const JobCard = ({clientRef,DateRaised,tradeCode}) => {
    const classes = useStyles();
    let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 
    var prefix = "";
    var dateRaised = moment(DateRaised).format('DD/MM HH:mm');
    switch(sessionObj.Client.Name){
        case "Red Kite Housing":
            prefix = "rk"
            break;
        case "Look Ahead":
            prefix="lk";
            break;

    }
    return (
            <Paper className={classes.Paper}>
            <Link className={classes.Link} to={`/${prefix}job/${clientRef}?tradecode=${tradeCode}`}
            
            >
                <Typography variant="body1" className={classes.Typog}>{clientRef}</Typography>
                <Typography variant="body2" >{dateRaised}</Typography>

                

            </Link>
            </Paper>
    )
}
